<script>
	export default {
		name: 'ChatExecuter',
		methods: {
			getChats() {
				const self_ = this;

				const uid_ = self_.getCurrentUser('uid')

				const filter_ = {
					field: 'users',
					value: [ uid_, 'all' ]
				}

				return self_.getFirestoreCollection('chats', filter_, 0)
			},
			getChatByKey(key) {
				const self_ = this;

				return self_.getFirestoreDocument('chats', key)
			}
		}
	}
</script>